import React, { useRef, useEffect, useCallback, useMemo } from 'react';
import { toast } from 'react-toastify';

import { isArray } from 'lodash';
import { parseISO, format } from 'date-fns';

import { Modal } from '~/components';
import { t } from '~/helpers';
import api from '~/services/api';

import Form from './components/Form';
import GroupCharts from './components/GroupCharts';

export default function GraficoTanqueUnico() {
  const modalRef = useRef(null);
  const graphRef = useRef(null);

  const actionsGraph = useMemo(
    () => [
      {
        label: 'Voltar',
        color: 'secondary',
        variant: 'text',
        callback: () => graphRef.current.handleCloseModal(),
        autoFocus: true,
      },
    ],
    []
  );

  const handleSubmit = useCallback(async (data) => {
    try {
      const response = await api.get('graficotanqueunico', { params: data });

      const heights = response.data.map((i) => i.META_ALTURA);
      const temperatures = response.data.map((i) => i.META_TEMP_MEDIA);
      const volumes = response.data.map((i) => i.META_VOL_TOT);
      const categories = response.data.map((i) =>
        format(parseISO(i.META_DATAHORA), 'dd/MM/yyyy HH:mm')
      );

      graphRef.current.handleOpenModal({
        categories,
        heights,
        temperatures,
        volumes,
        form: data.codPosto,
      });
    } catch (err) {
      if (isArray(err)) err.map((e) => toast.error(t(e)));
      else toast.error(t(err));
    }
  }, []);

  useEffect(() => {
    modalRef.current.handleOpenModal();
  }, []);

  return (
    <>
      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={modalRef}
        title="Opções de Impressão"
        labelConfirm="Relatório"
        labelCancell="Cancelar"
        maxWidth="sm"
        component={(rest) => <Form submiting={handleSubmit} {...rest} />}
      />

      <Modal
        disableBackdropClick
        disableEscapeKeyDown
        ref={graphRef}
        title="Gráfico"
        actions={actionsGraph}
        component={GroupCharts}
      />
    </>
  );
}
